var Cryptlib = require('cryptlib')

// const APIIV = '1xQrEDlXTNYEQ7LD4DO9M1qF3jGaUz'; // Iv profile got from config API in webchat
// const secretKey = '919384032015' // username/userid
// const APIIV = '93tQxFCT8ozYSkkDX8alRAzkmx6out';

const decryptAPIData = (encryptedData, secretKey) => {
    try {
        const key = Cryptlib.getHashSha256(secretKey, 32);
        return decodeURIComponent(Cryptlib.decrypt(encryptedData, key, process.env.REACT_APP_ENCRYPT_IV));
    } catch (error) {
        return encryptedData;
    }
};

export const decryptData = (encryptedData, secretKey) => {
    if(!encryptedData || !secretKey) return encryptedData;
    return decryptAPIData(encryptedData, secretKey);
}